import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { COMMAND_PRIORITY_HIGH, PASTE_COMMAND, $getSelection, $insertNodes } from 'lexical';
import { $createImageInputNode } from '../../nodes/ImageInputNode';


export function ImagePastePlugin() {
  const [editor] = useLexicalComposerContext();
  
  useEffect(() => {
    return editor.registerCommand(
      PASTE_COMMAND,
      (event) => {
        const clipboardData = event.clipboardData;
        if (!clipboardData) return false;

        const items = Array.from(clipboardData.items);
        const imageItems = items.filter(item => item.type.startsWith('image/'));
        
        if (imageItems.length > 0) {
          event.preventDefault();
          
          const files = [];
          const filePromises = imageItems.map(item => {
            return new Promise((resolve) => {
              const file = item.getAsFile();
              if (file) {
                files.push(file);
              }
              resolve();
            });
          });

          Promise.all(filePromises).then(() => {
            if (files.length > 0) {
              editor.update(() => {
                const selection = $getSelection();
                if (selection) {
                  const imageInputNode = $createImageInputNode({
                    files: files,
                    multiple: files.length > 1,
                  });
                  
                  $insertNodes([imageInputNode]);
                }
              });
            }
          });
          
          return true;
        }

        return false;
      },
      COMMAND_PRIORITY_HIGH
    );
  }, [editor]);
  
  return null;
}